'use client';

import { useEffect } from 'react';
import { useStore } from 'zustand';

import { usePortalAcesso } from '@/domain/portal/hooks/usePortalAcesso';
import { authStore } from '@/infrastructure/store/authStore';
import { configuracaoStore } from '@/infrastructure/store/configuracaoStore';

/**
 * Loads the factory parameters ONCE per session and account, from the layout. Plain helpers
 * read them outside React (the factory's day in `hojeNaFabricaISO`, the trash period), so they
 * have to be in hand on every screen, not only on the ones that load them.
 *
 * Gated on the unified login, because the layout mounts outside `AuthGuard` and a request
 * leaving before the token comes back 401, and on the person being factory staff: a brand
 * buyer only reaches the Portal, and the API refuses them everything else.
 */
export function useConfiguracaoBootstrap(): void {
  const isAuthenticated = useStore(authStore, (s) => s.isAuthenticated);
  const partnerId = useStore(authStore, (s) => s.user?.partnerId ?? '');
  const load = useStore(configuracaoStore, (s) => s.load);
  const { isStaff } = usePortalAcesso();

  useEffect(() => {
    if (!isAuthenticated || partnerId === '' || !isStaff) {
      return;
    }
    const run = async (): Promise<void> => {
      await load();
    };
    run();
  }, [isAuthenticated, partnerId, isStaff, load]);
}
